





















































import Vue from 'vue';
import { Component, Mixins } from 'vue-property-decorator';
import moment from 'moment';
import LuxtagMixin from '@/assets/ts/luxtagMixin';
import LuxTagApi from '@/api';

@Component({
  filters: {
    filterMonth(value: any) {
      return (moment(value).format('MMM')).toUpperCase();
    },
    filterDate(value: any) {
      return moment(value).format('DD');
    }
  }
})
export default class Home extends Mixins(LuxtagMixin) {
  public eventsToday: any = [];
  public eventsUpcoming: any = [];

  public beforeRouteEnter(to: any, from: any, next: any) {
    next((vm: any) => {
      // access to component instance via `vm`
      vm.$store.commit('MUTATE_SHOW_NAVIGATION', true);
      vm.$store.commit('MUTATE_TITLE', 'Event List');
      vm.$store.commit('MUTATE_HEADER_STYLE', false);
    });
  }

  public beforeRouteLeave(to: any, from: any, next: any) {
    this.$store.commit('MUTATE_SHOW_NAVIGATION', false);
    this.$store.commit('MUTATE_TITLE', '');
    next();
  }

  public created() {
    // console.log('created');
    this.getTodayEvents();
    this.getUpcomingEvents();
    // console.log(this.events);
  }
  public async getTodayEvents() {
    const data = {
      _sort: 'name:asc',
      date: moment().format('YYYY-MM-DD'),
      status: true
    };
    const response = await LuxTagApi.event.list(data);
    if (response) {
      // console.log(moment().format('YYYY-MM-DD'), response.data);
      this.eventsToday = response.data;
    }
    console.log(response);
  }
  public async getUpcomingEvents() {
    const data = {
      _sort: 'date:asc',
      date_gt: moment().format('YYYY-MM-DD'),
      status: true
    };
    const response = await LuxTagApi.event.list(data);
    if (response) {
      this.eventsUpcoming = response.data;
    }
  }
  public navigate(eventId: any) {
    // console.log(eventId);
    this.$router.push({ path: `/detail/${eventId}` });
  }
}
